// extracted by mini-css-extract-plugin
export default {"section":"bB43l","section-block":"aLcoY"};